import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import axios from 'axios';

import {
  Link,
  Button,
  Preloader,
  Status,
  TextInput,
  RadioButton,
  RadioGroup,
  Icon,
  I18n,
} from 'components';
import { formatMac } from 'utils/formatString';

import Service from '../Service';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

export default class TvDevice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDisconnectDialogVisible: false,
      isAliasFormVisible: false,
      isReturnFormVisible: false,
      disconnectionStatus: null,
      returnParams: null,
      returnOption: null,
      label: this.props.label,
      error: null,
    };
  }

  returnDevice = () => {
    const { RentReturnConsole } = window.QA.Beeline.Pages.HomeTariff;

    this.setState({ isReturnFormVisible: false });

    try {
      RentReturnConsole.ShowRentReturnCard({
        IsSubmit: false,
        Action: RentReturnConsole.RentActionTypeEnum().Return,
        EquipmentsType: RentReturnConsole.EquipmentTypeEnum().Console,
      });
    } catch (error) {
      this.setState({ error });
    }
  }

  toggleDisconnectDialog = () => this.setState((prevState) => ({
    isDisconnectDialogVisible: !prevState.isDisconnectDialogVisible,
    isAliasFormVisible: false,
    isReturnFormVisible: false,
    error: null,
  }))

  toggleAliasForm = () => this.setState((prevState) => ({
    isAliasFormVisible: !prevState.isAliasFormVisible,
    isDisconnectDialogVisible: false,
    isReturnFormVisible: false,
    error: null,
  }))

  toggleReturnForm = async () => {
    this.setState((prevState) => ({
      isReturnFormVisible: !prevState.isReturnFormVisible,
      isAliasFormVisible: false,
      isDisconnectDialogVisible: false,
      error: null,
    }));

    if (this.state.returnParams) return;

    const { guid } = this.props;

    try {
      const { data } = await axios.get('/api/profile/convergence/iptvrentconsolereturninfo/', { params: { guid } });
      if (data) {
        this.setState({
          returnParams: data,
          returnOption: data.courier && data.courier.enabled ? 'courier' : 'office',
        });
      } else {
        this.setState({
          error: {
            message: 'При выполнении операции произошла ошибка. Попробуйте еще раз',
          },
          isReturnFormVisible: false,
        });
      }
    } catch (error) {
      this.setState({ error, isReturnFormVisible: false });
    }
  }

  saveAlias = async (event) => {
    event.preventDefault();

    const { guid, guidBrand } = this.props;
    const alias = event.target.elements.alias.value.trim();

    this.setState({
      isAliasFormVisible: false,
      label: alias,
    });

    const { data } = await axios.post('/api/profile/convergence/equipmentalias/', {
      equipmentId: guid,
      equipmentType: guidBrand ? 'TVE' : 'CON',
      alias,
    });

    if (!data.isSuccess) {
      this.setState({
        label: this.props.label,
        error: {
          message: 'Ошибка при сохранении метки',
          code: data.errorCode,
        },
      });
    }
  }

  disconnectDevice = async () => {
    const { guid, guidFamily } = this.props;

    this.setState({
      disconnectionStatus: 'LOADING',
      error: null,
    });

    try {
      const { data } = await axios.post('/api/profile/convergence/disabletvedevice/', {
        guid,
        guidFamily,
      });

      if (data.isSuccess) {
        this.setState({
          disconnectionStatus: 'SUCCESS',
          isDisconnectDialogVisible: false,
        });
      } else {
        this.setState({
          disconnectionStatus: null,
          isDisconnectDialogVisible: false,
          error: {
            message: 'Ошибка при отключении устройства',
            code: data.errorCode,
          },
        });
      }
    } catch (error) {
      this.setState({
        disconnectionStatus: null,
        isDisconnectDialogVisible: false,
        error: { message: 'Ошибка при отключении устройства' },
      });
    }
  }

  render() {
    const {
      mac,
      serial,
      guid,
      guidType,
      guidBrand,
      guidFamily,
      price,
      ratePeriod,
      multiroom,
      isRent,
      isConsole,
      isTve,
      isMain,
      isBlocked,
    } = this.props;
    const {
      label,
      disconnectionStatus,
      returnParams,
      returnOption,
      isDisconnectDialogVisible,
      isAliasFormVisible,
      isReturnFormVisible,
      error,
    } = this.state;

    return (
      <div className={cx('component')}>
        <div className={cx('device')}>
          <div className={cx('type')}>
            {isTve ? guidFamily : 'Приставка'}
          </div>

          <div className={cx('name')}>
            {isAliasFormVisible ? (
              <form onSubmit={this.saveAlias}>
                <TextInput
                  value={label}
                  name="alias"
                  maxLength={30}
                />
                <div className={cx('formControls')}>
                  <Button className="default">
                    Переименовать
                  </Button>
                  <Link
                    className={cx('formLink')}
                    onClick={this.toggleAliasForm}
                  >
                    Отменить
                  </Link>
                </div>
              </form>
            ) : (
              <>
                {isTve ? (
                  <>
                    {isConsole && 'ТВ-приставка '}
                    {label || guidBrand || guidType}
                  </>
                ) : (
                  <>
                    <Link
                      onClick={this.toggleAliasForm}
                    >
                      {isConsole && `${isMain ? 'ТВ-приставка ' : 'Дополнительная ТВ-приставка '}`}
                      {label
                        ? `${guidBrand || guidType} ${label}`
                        : (guidBrand || guidType)}
                    </Link>
                    <button
                      className={cx('editButton')}
                      type="button"
                      onClick={this.toggleAliasForm}
                    >
                      <Icon
                        className={cx('editIcon')}
                        name="edit"
                      />
                    </button>
                  </>
                )}
              </>
            )}

            {isDisconnectDialogVisible && (
              <Status className={cx('disconnectionForm')}>
                {disconnectionStatus === 'LOADING' ? (
                  <Preloader
                    className={cx('preloader')}
                    size="48"
                  />
                ) : (
                  <>
                    <div className={cx('formName')}>
                      Отключение
                      {' '}
                      {isConsole ? 'приставки' : 'устройства'}
                    </div>
                    <div className={cx('formControls')}>
                      <Button
                        className="default"
                        onClick={this.disconnectDevice}
                      >
                        Подтвердить
                      </Button>
                      <Link
                        className={cx('formLink')}
                        onClick={this.toggleDisconnectDialog}
                      >
                        Отменить
                      </Link>
                    </div>
                  </>
                )}
              </Status>
            )}

            {isReturnFormVisible && (
              <Status className={cx('returnForm')}>
                {returnParams ? (
                  <>
                    <div className={cx('formName')}>
                      Выберите способ возврата приставки
                    </div>
                    <RadioGroup
                      className={cx('returnOptions')}
                      value={returnOption}
                      onChange={(value) => this.setState({ returnOption: value })}
                      name={`return-options-${guid}`}
                    >
                      {returnParams.courier && returnParams.courier.enabled && (
                        <RadioButton value="courier">
                          <span className={cx('returnOptionName')}>
                            Вернуть с курьером
                          </span>
                          {returnParams.courier.price}
                          {' '}
                          ₽
                        </RadioButton>
                      )}
                      {returnParams.office && returnParams.office.enabled && (
                        <RadioButton value="office">
                          <span className={cx('returnOptionName')}>
                            Привезти в офис самому
                          </span>
                          Бесплатно
                        </RadioButton>
                      )}
                    </RadioGroup>
                    {returnOption === 'courier' && (
                      <div className={cx('formControls')}>
                        <Button
                          className="default"
                          onClick={this.returnDevice}
                        >
                          К возврату
                        </Button>
                        <Link
                          className={cx('formLink')}
                          onClick={this.toggleReturnForm}
                        >
                          Отменить
                        </Link>
                      </div>
                    )}
                    {returnOption === 'office' && (
                      <div className={cx('returnText')}>
                        Вы можете вернуть приставку в одном из
                        {' '}
                        <Link href={returnParams.office.link} target="_blank">
                          наших офисов
                        </Link>
                        {' '}
                        или
                        {' '}
                        <Link onClick={this.toggleReturnForm}>
                          отменить возврат
                        </Link>
                      </div>
                    )}
                  </>
                ) : (
                  <Preloader
                    className={cx('preloader')}
                    size="48"
                  />
                )}
              </Status>
            )}
          </div>

          <div className={cx('info')}>
            {mac && (
              <I18n
                className={cx('mac')}
                path="tv.devices.mac"
                vars={{ mac: formatMac(mac) }}
              />
            )}

            {!mac && serial && (
              <div>
                <I18n
                  className={cx('serial')}
                  path="tv.devices.serial"
                  vars={{ serial }}
                />
              </div>
            )}

            {!mac && !serial && guid && (
              <div>
                <I18n
                  className={cx('guid')}
                  path="tv.devices.guid"
                  vars={{ guid }}
                />
              </div>
            )}

            {isRent && !isReturnFormVisible && (
              <div className={cx('backLink')}>
                <Link onClick={this.toggleReturnForm}>
                  Вернуть приставку
                </Link>
              </div>
            )}

            {isTve && !isRent && !isDisconnectDialogVisible && (
              <Link onClick={this.toggleDisconnectDialog}>
                Отключить
                {' '}
                {isConsole ? 'приставку' : 'устройство'}
              </Link>
            )}
          </div>

          <div className={cx('price')}>
            {isConsole && (
              <>
                {isRent && (
                  <div className={cx('status')}>
                    В аренде
                  </div>
                )}
                {isRent ? `${price} ₽ ${ratePeriod}` : 'Куплена'}
              </>
            )}
          </div>
        </div>

        {multiroom && (
          <Service
            className={cx('multiroom')}
            name="Мультирум"
            isBlocked={isBlocked}
            {...multiroom}
          />
        )}

        {error && (
          <Status className={[cx('error'), 'error']} emoji="statusFail">
            {error.message}
          </Status>
        )}

        {disconnectionStatus === 'SUCCESS' && (
          <Status className={[cx('message'), 'success']}>
            Запрос на отключение устройства успешно создан. Отключение произойдёт в ближайшее время
          </Status>
        )}
      </div>
    );
  }
}

TvDevice.defaultProps = {
  ratePeriod: 'в месяц',
};

TvDevice.propTypes = {
  mac: PropTypes.string,
  serial: PropTypes.string,
  label: PropTypes.string,
  guid: PropTypes.string,
  guidType: PropTypes.string,
  guidFamily: PropTypes.string,
  guidBrand: PropTypes.string,
  price: PropTypes.number,
  ratePeriod: PropTypes.string,
  multiroom: PropTypes.object,
  isRent: PropTypes.bool,
  isConsole: PropTypes.bool,
  isTve: PropTypes.bool,
  isMain: PropTypes.bool,
  isBlocked: PropTypes.bool,
};
